import React from 'react';
import { LucideProps } from 'lucide-react';
import Image, { ImageProps } from 'next/image';
import GoogleLogo from './google-logo.svg';

export const GoogleIcon = ((props: Omit<ImageProps, 'alt' | 'src'>): React.JSX.Element => (
  <Image alt="Google logo" src={GoogleLogo} {...props} />
)) as React.FC<LucideProps>;
